import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'apsis-back-office-private-domain-not-found',
  templateUrl: './private-domain-not-found.component.html',
  styleUrls: ['./private-domain-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrivateDomainNotFoundComponent {}
